
























































































































































import { Component, Watch, Vue } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import { BPagination } from "bootstrap-vue";
import { ScheduleView } from "@/store/modules/enums";
import RemindersPopover from "@/components/schedule/Reminders.vue";
import ArchivePopover from "@/components/schedule/Archive.vue";
import UpdateStatusPopover from "@/components/schedule/UpdateStatus.vue";
import UpdateLangPopover from "@/components/schedule/UpdateLang.vue";
import SelectPopover from "@/components/SelectPopover.vue";
import OpenNotificationsPopover from "@/components/schedule/OpenNotifications.vue";

@Component({
  components: {
    BPagination,
    RemindersPopover,
    SelectPopover,
    ArchivePopover,
    UpdateStatusPopover,
    UpdateLangPopover,
    OpenNotificationsPopover
  },
  computed: {
    ...mapState("schedule", ["view", "list", "calendars"]),
    ...mapGetters("schedule", ["checkedRows"]),
  },
})
export default class Pager extends Vue {
  view!: ScheduleView;
  list!: any;
  showReminders = false;
  showArchive = false;
  showUpdateStatus = false;
  showUpdateLang = false;
  showOpenNotifications = false;

  @Watch("checkedRows", { deep: true })
  onFilterChanged() {
    this.hideAll(null);
  }

  setPageNumber(page: number) {
    this.$store.commit("schedule/SET_PAGE_NUMBER", page);
  }
  setRowsPerPage(e) {
    this.$store.commit("schedule/SET_ROWS_PER_PAGE", e.target.value);
  }
  setView(view: ScheduleView) {
    this.$store.commit("schedule/SET_VIEW", view);
  }
  setCalendarFilter(value: number[]) {
    this.$store.commit("schedule/SET_CALENDAR_FILTER", value);

  }
  clear() {
    this.$store.commit("schedule/RESET_FILTER");
  }
  check() {
    this.$store.commit("schedule/CHECK_PAGE_ROWS");
  }
  uncheck() {
    this.$store.commit("schedule/UNCHECK_PAGE_ROWS");
  }

  show(opt) {
    //this.showArchive = !  this.showArchive;
    switch (opt) {
      case "archive":
        this.showArchive = !this.showArchive;
        this.hideAll(opt);
        break;
      case "status":
        this.showUpdateStatus = !this.showUpdateStatus;
        this.hideAll(opt);
        break;
      case "lang":
        this.showUpdateLang = !this.showUpdateLang;
        this.hideAll(opt);
        break;
        case "reminders":
        this.showReminders = !this.showReminders;
        this.hideAll(opt);
        break;
        case "op_notifications":
        this.showOpenNotifications = !this.showOpenNotifications;
        this.hideAll(opt);
        break;
      default:
        break;
    }

  }

  hideAll(opt) {
   // x=2;
    switch (opt) {
      case "archive":
        this.showUpdateStatus = false;
        this.showUpdateLang = false;
        this.showOpenNotifications = false;
        this.showReminders = false;
        break;
      case "status":
        this.showArchive = false;
        this.showUpdateLang = false;
        this.showOpenNotifications = false;
        this.showReminders = false;
        break;
      case "lang":
        this.showArchive = false;
        this.showUpdateStatus = false;
        this.showOpenNotifications = false;
        this.showReminders = false;
        break;
      case "op_notifications":
        this.showArchive = false;
        this.showUpdateStatus = false;
        this.showUpdateLang = false;
        this.showReminders = false;
        break;
      case "reminders":
        this.showArchive = false;
        this.showUpdateStatus = false;
        this.showUpdateLang = false;
        this.showOpenNotifications = false;
        break;
      default:
       /* this.showArchive = false;
        this.showUpdateStatus = false;
        this.showUpdateLang = false;
        this.showOpenNotifications = false;
        this.showReminders = false;*/
        break;
    }

  }
  get ScheduleView() {
    return ScheduleView;
  }


  tomorrowFilter() {
    var timeSpan: any = null;
    var tomorrow: string = this.$moment().add(1, 'days').toString();
    var from: string = tomorrow;
    var to: string = tomorrow;

    this.$store.commit("schedule/SET_DATE_FILTER", { timeSpan, from, to });
  }
}
